import type { CoaAccount, CoaAccountType } from '../components/CoaPreview';
import { tr } from './i18nHelpers';

// Sections render in account-code order (1xxxx → 9xxxx), matching the HK 5-digit
// class sequence. Renumbering itself is driven by TYPE_CODE_RANGE, not this list.
export const TYPE_ORDER: CoaAccountType[] = ['asset', 'liability', 'equity', 'revenue', 'cost', 'expense', 'other_income', 'other_expense'];

export const TYPE_LABELS: Record<string, string> = {
  asset: tr('Assets', '資產', '资产'),
  liability: tr('Liabilities', '負債', '负债'),
  equity: tr('Equity', '權益', '权益'),
  revenue: tr('Revenue', '收入', '收入'),
  other_income: tr('Other Income', '其他收入', '其他收入'),
  cost: tr('Cost', '直接成本', '直接成本'),
  expense: tr('Expenses', '支出', '支出'),
  other_expense: tr('Other Expenses', '其他支出', '其他支出'),
};

export const TYPE_COLORS: Record<string, string> = {
  asset: 'bg-blue-50 text-black font-bold dark:bg-blue-900/30 dark:text-white',
  liability: 'bg-red-50 text-black font-bold dark:bg-red-900/30 dark:text-white',
  equity: 'bg-purple-50 text-black font-bold dark:bg-purple-900/30 dark:text-white',
  revenue: 'bg-green-50 text-black font-bold dark:bg-green-900/30 dark:text-white',
  other_income: 'bg-emerald-50 text-black font-bold dark:bg-emerald-900/30 dark:text-white',
  cost: 'bg-orange-50 text-black font-bold dark:bg-orange-900/30 dark:text-white',
  expense: 'bg-amber-50 text-black font-bold dark:bg-amber-900/30 dark:text-white',
  other_expense: 'bg-rose-50 text-black font-bold dark:bg-rose-900/30 dark:text-white',
};

/** Parent = some account's parent_code references this code (authoritative, not stem heuristic). */
export function isParentCode(
  code: string,
  accounts: Array<{ account_code: string; parent_code: string | null }>,
): boolean {
  if (!code) return false;
  return accounts.some(a => a.parent_code === code);
}

export function getDepth(code: string): number {
  if (!code) return 0;
  const stripped = code.replace(/0+$/, '');
  if (stripped.length <= 1) return 0;
  return Math.max(0, stripped.length - 1);
}

export function getDepthBgClass(code: string, accounts: CoaAccount[]): string {
  if (!code) return '';
  if (isParentCode(code, accounts)) {
    const depth = getDepth(code);
    if (depth === 0) return 'bg-slate-100';
    if (depth === 1) return 'bg-slate-50';
    if (depth === 2) return 'bg-white';
    return '';
  }
  return 'bg-white';
}
